import Vue from 'vue'
import Vuex from 'vuex'

import cf4 from './components/core/store/cf4'

Vue.use(Vuex);


export default new Vuex.Store({
    modules: {
        cf4,
    },
})
